<ng-container *ngIf="showNotification">
  <div class="notification" (click)="dismiss()">
    <button mat-button>
      <mat-icon>close</mat-icon>
    </button>
    <div [innerHTML]="notificationMessage"></div>
  </div>
</ng-container>

<ng-container *ngIf="(authService.isAuthenticated | async) && baseUrlPath !== 'auth' && baseUrlPath !== 'public'">
  <mat-toolbar *ngIf="!shouldSidenavOpen() && isMainMenuOpen">
    <mat-toolbar-row>
      <img
        [src]="'assets/images/logo.svg'"
        [routerLink]="fallbackView"
        alt="WebBuy"
        class="logo"
      />
      <span class="spacer"></span>
      <button mat-button (click)="sidenav.toggle()">
        <mat-icon>{{ sidenav.opened ? 'close' : 'menu' }}</mat-icon>
      </button>
    </mat-toolbar-row>
    <mat-toolbar-row *ngIf="isSubnavRoute() && !sidenav.opened">
      <h3>{{ submenuTitle }}</h3>
      <span class="spacer"></span>
      <button mat-button (click)="subnav.toggle()">
        <mat-icon>{{ subnav.opened ? 'close' : 'menu' }}</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <mat-sidenav-container
    id="container"
    [class.main-menu-hidden]="!isMainMenuOpen"
    [class.container-landscape-override]="displayService.isLandscape"
  >
    <mat-sidenav
      #sidenav
      [opened]="shouldSidenavOpen() && isMainMenuOpen"
      mode="side"
      id="sidenav"
      [fixedInViewport]="isFixedInViewport"
      [fixedTopGap]="fixedTopGap"
      [fixedBottomGap]="fixedBottomGap"
    >
      <ng-container *ngIf="!destroySideNav">
        <div id="logo-box">
          <img
            [src]="'assets/images/logo.svg'"
            [routerLink]="fallbackView"
            alt="WebBuy"
            class="logo"
            *ngIf="shouldSidenavOpen()"
          />
        </div>

        <div class="menu-list">
          <mat-nav-list
            *ngIf="permission?.dashboard?.view && permission?.dashboard?.edit"
            (click)="!shouldSidenavOpen() && sidenav.close() && subnav.close()"
          >
            <a mat-list-item [routerLink]="['/dashboard', accountService.currentUid]" [routerLinkActive]="'active'">
              <mat-icon svgIcon="iconCompass"></mat-icon>
              {{ 'dashboard.title' | translate }}
            </a>
          </mat-nav-list>
          <mat-nav-list
            *ngIf="permission?.clients?.view"
            (click)="!shouldSidenavOpen() && sidenav.close() && subnav.close()"
          >
            <a
              mat-list-item
              [routerLink]="['/accounts', accountService.currentUid, 'clients']"
              [routerLinkActive]="'active'"
            >
              <mat-icon>drive_eta</mat-icon>
              {{ 'viewAccount.clients.title' | translate }}
            </a>
          </mat-nav-list>
          <mat-nav-list
            *ngIf="permission?.inventory?.view"
            (click)="!shouldSidenavOpen() && sidenav.close() && subnav.close()"
          >
            <a
              mat-list-item
              [routerLink]="['/accounts', accountService.currentUid, 'inventory']"
              [routerLinkActive]="'active'"
            >
              <mat-icon>drive_eta</mat-icon>
              {{ 'viewAccount.inventory.title' | translate }}
            </a>
          </mat-nav-list>
          <mat-nav-list
            *ngIf="permission?.account?.view"
            (click)="!shouldSidenavOpen() && sidenav.close() && subnav.close()"
          >
            <a
              mat-list-item
              [routerLink]="['/accounts']"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              <mat-icon>drive_eta</mat-icon>
              {{ 'accounts.title' | translate }}
            </a>
          </mat-nav-list>
          <mat-nav-list
            *ngIf="permission?.groups?.view && externalRole"
            (click)="!shouldSidenavOpen() && sidenav.close() && subnav.close()"
          >
            <a mat-list-item [routerLink]="['/groups', accountService.currentUid]" [routerLinkActive]="'active'">
              <mat-icon>groups</mat-icon>
              {{ 'groups.title' | translate }}
            </a>
          </mat-nav-list>
          <mat-nav-list
            *ngIf="permission?.users?.view"
            (click)="!shouldSidenavOpen() && sidenav.close() && subnav.close()"
          >
            <a mat-list-item [routerLink]="['/users', accountService.currentUid, 'list']" [routerLinkActive]="'active'">
              <mat-icon>people</mat-icon>
              {{ 'users.title' | translate }}
            </a>
          </mat-nav-list>
          <mat-nav-list
            *ngIf="permission?.report?.view && externalRole"
            (click)="!shouldSidenavOpen() && sidenav.close() && subnav.close()"
          >
            <a mat-list-item [routerLink]="['/reports', accountService.currentUid]" [routerLinkActive]="'active'">
              <mat-icon>equalizer</mat-icon>
              {{ 'reports.title' | translate }}
            </a>
          </mat-nav-list>
          <mat-nav-list
            *ngIf="permission?.settings?.view"
            (click)="!shouldSidenavOpen() && sidenav.close() && subnav.close()"
          >
            <a mat-list-item [routerLink]="['/account-setup', accountService.currentUid]" [routerLinkActive]="'active'">
              <mat-icon>settings</mat-icon>
              {{ 'accountSettings.title' | translate }}
            </a>
          </mat-nav-list>
          <mat-nav-list
            *ngIf="permission?.system?.view && externalRole"
            (click)="!shouldSidenavOpen() && sidenav.close() && subnav.close()"
          >
            <a mat-list-item [routerLink]="['/system-settings']" [routerLinkActive]="'active'">
              <mat-icon>settings</mat-icon>
              {{ 'systemSettings.title' | translate }}
            </a>
          </mat-nav-list>
          <mat-nav-list
            *ngIf="permission?.support?.view"
            (click)="!shouldSidenavOpen() && sidenav.close() && subnav.close()"
          >
            <a mat-list-item [routerLink]="['/support/report-problem']" [routerLinkActive]="'active'">
              <mat-icon>help_outline</mat-icon>
              {{ 'support.title' | translate }}
            </a>
          </mat-nav-list>
        </div>

        <mat-card *ngIf="permission && !hideAnnouncement" class="announcement-card">
          <mat-icon (click)="dismissAnnouncement()" mat-dialog-close>close</mat-icon>
          <img *ngIf="announcementData.logo" src="{{ announcementData.logo }}"/>
          <h2>{{ announcementData.header | translate }}</h2>
          <p>{{ announcementData.body | translate }}</p>
          <a [href]="mailtoLink" target="_blank">
            <button mat-raised-button color="primary">{{ announcementData.button | translate }}</button>
          </a>
        </mat-card>

        <mat-card class="avatar-card">
          <mat-card-header>
            <img class="avatar" src="{{ image ?? 'assets/images/placeholder-person.png' }}"/>
            <mat-icon [matMenuTriggerFor]="userMenu">more_vert</mat-icon>
            <mat-card-title>{{ firstName }}</mat-card-title>
            <mat-card-subtitle>{{ lastName }}</mat-card-subtitle>
          </mat-card-header>
        </mat-card>

        <mat-menu #userMenu="matMenu">
          <button mat-menu-item [disabled]="!userUid || !accountService.currentUid" (click)="navigate('profile')">
            <mat-icon>manage_accounts</mat-icon>
            {{ 'profileSettings.profile.myProfile' | translate }}
          </button>
          <button mat-menu-item [disabled]="!userUid || !accountService.currentUid" (click)="navigate('notifications')">
            <mat-icon>notifications_active</mat-icon>
            {{ 'profileSettings.profile.notifications' | translate }}
          </button>
          <button mat-menu-item (click)="getSupportDetails()">
            <mat-icon>copy_all</mat-icon>
            {{ 'profileSettings.profile.supportRequest' | translate }}
          </button>
          <button
            *ngIf="permission?.inventory?.view"
            mat-menu-item
            [routerLink]="['/accounts', accountService.currentUid, 'inventory']"
            [queryParams]="{ tab: 2 }"
            [disabled]="!userUid || !accountService.currentUid"
            (click)="setKioskClass()"
          >
            <mat-icon>tab</mat-icon>
            {{ 'profileSettings.profile.enableKiosk' | translate }}
          </button>
          <mat-divider></mat-divider>
          <button mat-menu-item (click)="logout(['/auth'])">
            <mat-icon>power_settings_new</mat-icon>
            {{ 'common.logOut' | translate }}
          </button>
        </mat-menu>
      </ng-container>
    </mat-sidenav>

    <mat-sidenav-content [class.sidenav-content-offset]="!shouldSidenavOpen()">
      <mat-sidenav-container id="submenu" [class.main-menu-hidden]="!isMainMenuOpen">
        <mat-sidenav
          #subnav
          [opened]="shouldSidenavOpen() && isSubMenuOpen"
          mode="side"
          id="subnav"
          [fixedInViewport]="isFixedInViewport"
          [fixedTopGap]="fixedTopGap"
          [fixedBottomGap]="fixedBottomGap"
          [class.subnav-menu-sizing]="!shouldSidenavOpen()"
          [ngStyle]="{ 'width.px': !shouldSidenavOpen() ? currentWidth : null }"
        >
          <div *ngIf="routeData?.route === 'ACCOUNT_SETTINGS'">
            <ng-container *ngIf="shouldSidenavOpen()">
              <h3>{{ 'accountSettings.title' | translate }}</h3>
            </ng-container>
            <mat-divider></mat-divider>
            <mat-nav-list *ngIf="permission?.settings?.view">
              <a
                mat-list-item
                [routerLink]="['/account-setup', accountService.currentUid]"
                [routerLinkActive]="'active'"
                (click)="!shouldSidenavOpen() ? subnav.toggle() : null"
              >
                {{ 'accountSettings.accountSetup.title' | translate }}
                <mat-icon
                  [class.mat-icon-override]="isSubnavRoute() && !shouldSidenavOpen()"
                  svgIcon="iconArrowRight"
                ></mat-icon>
              </a>
            </mat-nav-list>
            <mat-nav-list *ngIf="permission?.settings?.view">
              <a
                mat-list-item
                [routerLink]="['/customization', accountService.currentUid]"
                [routerLinkActive]="'active'"
                (click)="!shouldSidenavOpen() ? subnav.toggle() : null"
              >
                {{ 'accountSettings.customization.title' | translate }}
                <mat-icon
                  [class.mat-icon-override]="isSubnavRoute() && !shouldSidenavOpen()"
                  svgIcon="iconArrowRight"
                ></mat-icon>
              </a>
            </mat-nav-list>
            <mat-nav-list *ngIf="permission?.settings?.view">
              <a
                mat-list-item
                [routerLink]="['/pricing-fees', accountService.currentUid]"
                [routerLinkActive]="'active'"
                (click)="!shouldSidenavOpen() ? subnav.toggle() : null"
              >
                {{ 'accountSettings.pricingAndFees.title' | translate }}
                <mat-icon
                  [class.mat-icon-override]="isSubnavRoute() && !shouldSidenavOpen()"
                  svgIcon="iconArrowRight"
                ></mat-icon>
              </a>
            </mat-nav-list>
            <mat-nav-list *ngIf="permission?.settings?.view">
              <a
                mat-list-item
                [routerLink]="['/accessories', accountService.currentUid]"
                [routerLinkActive]="'active'"
                (click)="!shouldSidenavOpen() ? subnav.toggle() : null"
              >
                {{ 'accountSettings.accessories.title' | translate }}
                <mat-icon
                  [class.mat-icon-override]="isSubnavRoute() && !shouldSidenavOpen()"
                  svgIcon="iconArrowRight"
                ></mat-icon>
              </a>
            </mat-nav-list>
            <mat-nav-list *ngIf="permission?.settings?.view">
              <a
                mat-list-item
                [routerLink]="['/trade-in', accountService.currentUid]"
                [routerLinkActive]="'active'"
                (click)="!shouldSidenavOpen() ? subnav.toggle() : null"
              >
                {{ 'accountSettings.tradeIn.title' | translate }}
                <mat-icon
                  [class.mat-icon-override]="isSubnavRoute() && !shouldSidenavOpen()"
                  svgIcon="iconArrowRight"
                ></mat-icon>
              </a>
            </mat-nav-list>
            <mat-nav-list *ngIf="permission?.settings?.view">
              <a
                mat-list-item
                [routerLink]="['/protection', accountService.currentUid]"
                [routerLinkActive]="'active'"
                (click)="!shouldSidenavOpen() ? subnav.toggle() : null"
              >
                {{ 'accountSettings.protection.title' | translate }}
                <mat-icon
                  [class.mat-icon-override]="isSubnavRoute() && !shouldSidenavOpen()"
                  svgIcon="iconArrowRight"
                ></mat-icon>
              </a>
            </mat-nav-list>
            <mat-nav-list *ngIf="permission?.users?.view">
              <a
                mat-list-item
                [routerLink]="['/users', accountService.currentUid]"
                [routerLinkActive]="'active'"
                (click)="!shouldSidenavOpen() ? subnav.toggle() : null"
              >
                {{ 'userMenu.title' | translate }}
                <mat-icon
                  [class.mat-icon-override]="isSubnavRoute() && !shouldSidenavOpen()"
                  svgIcon="iconArrowRight"
                ></mat-icon>
              </a>
            </mat-nav-list>
            <mat-nav-list *ngIf="permission?.settings?.view">
              <a
                mat-list-item
                [routerLink]="['/criteria', accountService.currentUid]"
                [routerLinkActive]="'active'"
                (click)="!shouldSidenavOpen() ? subnav.toggle() : null"
              >
                {{ 'accountSettings.criteria.title' | translate }}
                <mat-icon
                  [class.mat-icon-override]="isSubnavRoute() && !shouldSidenavOpen()"
                  svgIcon="iconArrowRight"
                ></mat-icon>
              </a>
            </mat-nav-list>
            <!-- <mat-nav-list *ngIf="permission?.settings?.view">
              <a mat-list-item [routerLink]="['/billing', accountService.currentUid]" [routerLinkActive]="'active'">
                {{ 'accountSettings.billing.title' | translate }}
                <mat-icon [ngClass]="{'mat-icon-override': isSubnavRoute() && !shouldSidenavOpen()}" svgIcon="iconArrowRight"></mat-icon>
              </a>
            </mat-nav-list> -->
          </div>

          <div *ngIf="routeData?.route === 'SYSTEM_SETTINGS'">
            <ng-container *ngIf="shouldSidenavOpen()">
              <h3>
                {{ 'systemSettings.title' | translate }}
              </h3>
            </ng-container>
            <mat-divider></mat-divider>
            <mat-nav-list>
              <a
                mat-list-item
                [routerLink]="['system-settings']"
                [routerLinkActive]="'active'"
                [routerLinkActiveOptions]="{ exact: true }"
                (click)="!shouldSidenavOpen() ? subnav.toggle() : null"
              >
                {{ 'systemSettings.systemStatus.title' | translate }}
                <mat-icon
                  [class.mat-icon-override]="isSubnavRoute() && !shouldSidenavOpen()"
                  svgIcon="iconArrowRight"
                ></mat-icon>
              </a>
            </mat-nav-list>
            <!-- <mat-nav-list>
              <a mat-list-item [routerLink]="['/system-settings/user-roles']" [routerLinkActive]="'active'">
                {{ 'systemSettings.userRoles.title' | translate }}
                <mat-icon [ngClass]="{'mat-icon-override': isSubnavRoute() && !shouldSidenavOpen()}" svgIcon="iconArrowRight"></mat-icon>
              </a>
            </mat-nav-list> -->
            <mat-nav-list>
              <a
                mat-list-item
                [routerLink]="['/system-settings/inventory-profiles']"
                [routerLinkActive]="'active'"
                (click)="!shouldSidenavOpen() ? subnav.toggle() : null"
              >
                {{ 'systemSettings.inventoryProfiles.title' | translate }}
                <mat-icon
                  [class.mat-icon-override]="isSubnavRoute() && !shouldSidenavOpen()"
                  svgIcon="iconArrowRight"
                ></mat-icon>
              </a>
            </mat-nav-list>
            <mat-nav-list>
              <a
                mat-list-item
                [routerLink]="['/system-settings/shared-inventory-feeds']"
                [routerLinkActive]="'active'"
                (click)="!shouldSidenavOpen() ? subnav.toggle() : null"
              >
                {{ 'systemSettings.SharedInventoryFeeds.title' | translate }}
                <mat-icon
                  [class.mat-icon-override]="isSubnavRoute() && !shouldSidenavOpen()"
                  svgIcon="iconArrowRight"
                ></mat-icon>
              </a>
            </mat-nav-list>
            <mat-nav-list>
              <a
                mat-list-item
                [routerLink]="['/system-settings/billing-profiles']"
                [routerLinkActive]="'active'"
                (click)="!shouldSidenavOpen() ? subnav.toggle() : null"
              >
                {{ 'systemSettings.billingProfiles.title' | translate }}
                <mat-icon
                  [class.mat-icon-override]="isSubnavRoute() && !shouldSidenavOpen()"
                  svgIcon="iconArrowRight"
                ></mat-icon>
              </a>
            </mat-nav-list>
            <mat-nav-list>
              <a
                mat-list-item
                [routerLink]="['/system-settings/default-credit-rates']"
                [routerLinkActive]="'active'"
                (click)="!shouldSidenavOpen() ? subnav.toggle() : null"
              >
                {{ 'systemSettings.defaultCreditRates.title' | translate }}
                <mat-icon
                  [class.mat-icon-override]="isSubnavRoute() && !shouldSidenavOpen()"
                  svgIcon="iconArrowRight"
                ></mat-icon>
              </a>
            </mat-nav-list>
            <mat-nav-list>
              <a
                mat-list-item
                [routerLink]="['/system-settings/body-styles']"
                [routerLinkActive]="'active'"
                (click)="!shouldSidenavOpen() ? subnav.toggle() : null"
              >
                {{ 'systemSettings.bodyStyles.title' | translate }}
                <mat-icon
                  [class.mat-icon-override]="isSubnavRoute() && !shouldSidenavOpen()"
                  svgIcon="iconArrowRight"
                ></mat-icon>
              </a>
            </mat-nav-list>
            <mat-nav-list>
              <a
                mat-list-item
                [routerLink]="['/system-settings/approved-lenders']"
                [routerLinkActive]="'active'"
                (click)="!shouldSidenavOpen() ? subnav.toggle() : null"
              >
                {{ 'systemSettings.approvedLenders.title' | translate }}
                <mat-icon
                  [class.mat-icon-override]="isSubnavRoute() && !shouldSidenavOpen()"
                  svgIcon="iconArrowRight"
                ></mat-icon>
              </a>
            </mat-nav-list>
            <mat-nav-list>
              <a
                mat-list-item
                [routerLink]="['/system-settings/integrations']"
                [routerLinkActive]="'active'"
                (click)="!shouldSidenavOpen() ? subnav.toggle() : null"
              >
                {{ 'systemSettings.integrations.title' | translate }}
                <mat-icon
                  [class.mat-icon-override]="isSubnavRoute() && !shouldSidenavOpen()"
                  svgIcon="iconArrowRight"
                ></mat-icon>
              </a>
            </mat-nav-list>
            <!-- <mat-nav-list>
              <a mat-list-item>
                {{ 'systemSettings.aggregators.title' | translate }}
                <mat-icon [ngClass]="{'mat-icon-override': isSubnavRoute() && !shouldSidenavOpen()}" svgIcon="iconArrowRight"></mat-icon>
              </a>
            </mat-nav-list> -->
          </div>
        </mat-sidenav>

        <mat-sidenav-content [class.subnav-content-offset]="!shouldSidenavOpen()">
          <main>
            <router-outlet *ngIf="authService.isAuthenticated | async"></router-outlet>
          </main>
        </mat-sidenav-content>
      </mat-sidenav-container>
    </mat-sidenav-content>
  </mat-sidenav-container>

  <figure *ngIf="userService.getKioskModeEnabled" class="kioskTag" (click)="unsetKioskClass()">
    <mat-icon>lock</mat-icon>
    <figcaption>{{ 'profileSettings.profile.kioskNotice' | translate }}</figcaption>
  </figure>
</ng-container>

<router-outlet
  *ngIf="(authService.isAuthenticated | async) === false || baseUrlPath === 'auth' || baseUrlPath === 'public'"
></router-outlet>

<!-- Loading Overlay -->
<ng-container *ngIf="loading">
  <div id="loading">
    <div class="loading-spinner">
      <mat-spinner diameter="64"></mat-spinner>
      <h3 *ngIf="loadingMessage">{{ loadingMessage }}</h3>
    </div>
    <div class="loading-backdrop"></div>
  </div>
</ng-container>
